import { Link } from "@inertiajs/react";

function FloatContact () {
    return(
        <a href="https://wa.me/6281939089993" target="_blank" className="float-wa shadow-md me-5 mb-4 rounded-circle">
                <img src="/images/icon/002-whatsapp-logo-variant@3x.png" alt="" />
        </a>
    )
}


export default FloatContact;